import { AfterViewInit, Component, OnInit } from "@angular/core";
import { AbstractPage } from "src/app/pages/abstract.page";
import ScrollReveal from "scrollreveal";
import { Meta } from "@angular/platform-browser";

@Component({
  selector: "app-landing-pharmacare",
  templateUrl: "./pharmacare.landing.html",
  styleUrls: ["./pharmacare.landing.scss"],
})
export class PharmacareCardLandingPage
  extends AbstractPage
  implements OnInit, AfterViewInit
{
  constructor(
    public meta: Meta,
  ) {
    super();
  }

  squareLink: string = 'https://square.link/u/nZaoj86f';

  ngOnInit(): void {
    
    this.meta.addTags([
      { name: "description", content: "Obtén la Tarjeta Pharmacare de MyTreat Health y disfruta de descuentos exclusivos en medicamentos, facilitando el acceso a tratamientos asequibles y mejorando tu bienestar." },
      { name: "keywords", content: "Tarjeta Pharmacare, descuentos en medicamentos, acceso a medicamentos asequibles, salud y bienestar, MyTreat Health" },
      { property: "og:title", content: "Tarjeta Pharmacare - Acceso a Medicamentos Asequibles | MyTreat Health" },
      { property: "og:description", content: "Descubre cómo la Tarjeta Pharmacare de MyTreat Health te ofrece descuentos exclusivos en medicamentos, facilitando tratamientos asequibles para tu bienestar." },
      { property: "og:image", content: "https://www.mytreat.health/api/files/marketplace/93418a62-789c-434e-8d81-55daa9836046.svg" },
      { property: "og:url", content: "https://www.mytreat.health/es/pharmacare-card/landing" },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "Tarjeta Pharmacare - Acceso a Medicamentos Asequibles | MyTreat Health" },
      { name: "twitter:description", content: "Descubre cómo la Tarjeta Pharmacare de MyTreat Health te ofrece descuentos exclusivos en medicamentos, facilitando tratamientos asequibles para tu bienestar." },
      { name: "twitter:image", content: "https://www.mytreat.health/api/files/marketplace/93418a62-789c-434e-8d81-55daa9836046.svg" }
    ]);
  }

  ngAfterViewInit(): void {
    const sr = ScrollReveal();

    sr.reveal(`.left-reveal`, {
      duration: 500,
      origin: "left",
      distance: "75px",
      easing: "cubic-bezier(0.175, 0.885, 0.32, 1.275)",
      reset: false,
      delay: 200,
      mobile: false,
      viewOffset: {
        bottom: 100,
      },
    });

    sr.reveal(`.right-reveal`, {
      duration: 500,
      origin: "right",
      distance: "175px",
      easing: "cubic-bezier(0.175, 0.885, 0.32, 1.275)",
      reset: false,
      delay: 200,
      mobile: false,
      viewOffset: {
        bottom: 100,
      },
    });

    sr.reveal(`.bottom-reveal`, {
      duration: 500,
      origin: "bottom",
      distance: "75px",
      easing: "cubic-bezier(0.175, 0.885, 0.32, 1.275)",
      reset: false,
      mobile: false,
      delay: 200,
      viewOffset: {
        bottom: 100,
      },
    });
  }

  scrollTo(id: string) {
    document.getElementById(id).scrollIntoView({
      behavior: "smooth",
      block: "center",
    });
  }

  public pageTitle(): string {
    return "MyTreat - Pharmacare Card";
  }
}
